export const nodeSizes = {
  CONFIGURATION_HEIGHT: 98,
  CONFIGURATION_HEIGHT_COMPACT: 52,
  FOLDER_HEIGHT: 52,
  FOLDER_HEIGHT_COMPACT: 48,
  NODE_INDENT: 32,
  NODE_INDENT_COMPACT: 6,
};
